import type IProfileRepository from '@/core/domain/profile/IProfileRepository.ts'
import { LocalUser } from '@/core/domain/users/LocalUser.ts'

export class FetchMeUseCase {
  private readonly profileRepository: IProfileRepository

  constructor(profileRepository: IProfileRepository) {
    this.profileRepository = profileRepository
  }

  async execute(): Promise<LocalUser> {
    return await this.profileRepository.fetchMe()
  }
}
